import { render, staticRenderFns } from "./adv-infinity-feed.component.vue?vue&type=template&id=cf8399ba&"
import script from "./adv-infinity-feed.component.vue?vue&type=script&lang=ts&"
export * from "./adv-infinity-feed.component.vue?vue&type=script&lang=ts&"
import style0 from "./adv-infinity-feed.component.vue?vue&type=style&index=0&id=cf8399ba&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports